export default "__VITE_ASSET__8831bb8b__"